import React from 'react';
import { AppColors } from 'src/themes/Colors';
import { metrics } from 'src/themes/Metrics';
import { Container } from './Container';
import { RegularText } from './RegularText';

export const TicketStatus = ({ status }: { status: 'Upcoming' | 'Canceled' | 'Departed' }) => {
  if (status === 'Canceled' || status === 'Departed' || status === 'Upcoming') {
    return (
      <Container
        borderRadius={50}
        paddingHorizontal={metrics.medium}
        paddingVertical={metrics.small}
        align="center"
        backgroundColor={AppColors.tripStatus[status].backgroundColor}>
        <RegularText fontSize="medium" color={AppColors.tripStatus[status].color} fontWeight="bold">
          {status.charAt(0).toUpperCase() + status.slice(1)}
        </RegularText>
      </Container>
    );
  }
  return null;
};
